export default function Django_PostgreSQL_Intro() {
  return <div>Django_PostgreSQL_Intro Component</div>;
}
